<template>
    <div class="city-wide">
        <ContentBox title="全网性同城配送型物流服务商" text="专业高效，保证服务品质与安全">
            <div class="top">
                <div class="tab">
                    <div class="tab-item" @click="showTab('tab0')">
                        <img class="tab-icon" src="../../images/icon/icon_fgg.png">
                        <div class="tab-title" :class="{'tab-title-on':current==='tab0'}">覆盖广</div>
                    </div>
                    <div class="tab-item" @click="showTab('tab1')">
                        <img class="tab-icon" src="../../images/icon/icon_sxk.png">
                        <div class="tab-title" :class="{'tab-title-on':current==='tab1'}">时效快</div>
                    </div>
                    <div class="tab-item" @click="showTab('tab2')">
                        <img class="tab-icon" src="../../images/icon/icon_fwy.png">
                        <div class="tab-title" :class="{'tab-title-on':current==='tab2'}">服务优</div>
                    </div>
                    <div class="tab-item" @click="showTab('tab3')">
                        <img class="tab-icon" src="../../images/icon/icon_bzq.png">
                        <div class="tab-title" :class="{'tab-title-on':current==='tab3'}">保障强</div>
                    </div>
                    <div class="arrow" :class="[current]"></div>
                </div>
            </div>
        </ContentBox>
        <div class="tab-content-title" v-show="!isMobile">
            <div class="container">
                <p>选择安得更省心更安心</p>
                <p>轻松解决各类配送痛点</p>
            </div>
        </div>
        <div class="tab-content-wrap" :class="{hide: current !== 'tab0'}">
            <div class="tab-content container">
                <div class="tab-content-title-mobel" v-show="isMobile">选择安得更省心更安心</div>
                <div class="content-item">
                    <img class="content-icon" src="../../images/icon/fgg_good.png">
                    <div class="content-ul">
                        <ul>
                            <li>
                                <span class="content-li"></span>
                                <span>深入区县乡镇</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>网络深度全国领先</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>全渠道全门店全覆盖</span>
                            </li>
                        </ul>
                    </div>
                    <div class="tapes">
                        <div class="tape"></div>
                        <div class="tape"></div>
                        <div class="tape"></div>
                    </div>
                </div>
                <div class="tab-content-title-mobel" v-show="isMobile">轻松解决各类配送痛点</div>
                <div class="content-item space">
                    <img
                        class="content-icon"
                        :class="{'icon-right':!isMobile}"
                        src="../../images/icon/fgg_bad.png"
                    >
                    <div class="content-ul" :class="{'text-right':!isMobile}">
                        <ul>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>无法做到一张网配送全国</span>
                            </li>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>地理位置偏远，不能实现配送上门</span>
                            </li>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>商超、KA卖场、等多种门店不能</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content-wrap" :class="{hide: current !== 'tab1'}">
            <div class="tab-content container">
                <div class="tab-content-title-mobel" v-show="isMobile">选择安得更省心更安心</div>
                <div class="content-item">
                    <img class="content-icon" src="../../images/icon/sxk_good.png">
                    <div class="content-ul">
                        <ul>
                            <li>
                                <span class="content-li"></span>
                                <span>万条班车路线，标准时效</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>线路全自营</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>全国千线当日达，全国万镇次日达</span>
                            </li>
                        </ul>
                    </div>
                    <div class="tapes">
                        <div class="tape"></div>
                        <div class="tape"></div>
                        <div class="tape"></div>
                    </div>
                </div>
                <div class="tab-content-title-mobel" v-show="isMobile">轻松解决各类配送痛点</div>
                <div class="content-item space">
                    <img
                        class="content-icon"
                        :class="{'icon-right':!isMobile}"
                        src="../../images/icon/sxk_bad.png"
                    >
                    <div class="content-ul" :class="{'text-right':!isMobile}">
                        <ul>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>旺季需要卖货时，货物还在路上，影响销量</span>
                            </li>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>渠道库存周转次数多，配送时效没保障</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content-wrap" :class="{hide: current !== 'tab2'}">
            <div class="tab-content container">
                <div class="tab-content-title-mobel" v-show="isMobile">选择安得更省心更安心</div>
                <div class="content-item">
                    <img class="content-icon" src="../../images/icon/fwy_good.png">
                    <div class="content-ul">
                        <ul>
                            <li>
                                <span class="content-li"></span>
                                <span>标准作业SOP流程</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>标准化增值服务</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>仓配整体规划及个性化需求定制能力</span>
                            </li>
                        </ul>
                    </div>
                    <div class="tapes">
                        <div class="tape"></div>
                        <div class="tape"></div>
                        <div class="tape"></div>
                    </div>
                </div>
                <div class="tab-content-title-mobel" v-show="isMobile">轻松解决各类配送痛点</div>
                <div class="content-item space">
                    <img
                        class="content-icon"
                        :class="{'icon-right':!isMobile}"
                        src="../../images/icon/fwy_bad.png"
                    >
                    <div class="content-ul" :class="{'text-right':!isMobile}">
                        <ul>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>随意、无序的服务，无法达到预期的要求</span>
                            </li>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>没法满足特色货物，特殊时间段的配送业务需求</span>
                            </li>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>不透明化配送，货物受损，无法落实责任与理赔</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content-wrap" :class="{hide: current !== 'tab3'}">
            <div class="tab-content container">
                <div class="tab-content-title-mobel" v-show="isMobile">选择安得更省心更安心</div>
                <div class="content-item">
                    <img class="content-icon" src="../../images/icon/bzq_good.png">
                    <div class="content-ul">
                        <ul>
                            <li>
                                <span class="content-li"></span>
                                <span>大品牌有保障，更安全，更规范</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>中国首批AAAAA级企业</span>
                            </li>
                            <li>
                                <span class="content-li"></span>
                                <span>配送全流程可视可追溯，保障供应链安全</span>
                            </li>
                        </ul>
                    </div>
                    <div class="tapes">
                        <div class="tape"></div>
                        <div class="tape"></div>
                        <div class="tape"></div>
                    </div>
                </div>
                <div class="tab-content-title-mobel" v-show="isMobile">轻松解决各类配送痛点</div>
                <div class="content-item space">
                    <img
                        class="content-icon"
                        :class="{'icon-right':!isMobile}"
                        src="../../images/icon/bzq_bad.png"
                    >
                    <div class="content-ul" :class="{'text-right':!isMobile}">
                        <ul>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>小型的配送公司，作业不规范，潜在风险大</span>
                            </li>
                            <li>
                                <span class="content-li float-li-icon"></span>
                                <span>小型的配送公司客户与业务单一，随时有倒闭的风险</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <ContentBox title="同城配送服务能力" text="客户可以根据需要考虑当仓发全省或仓辐射全省">
            <div class="bottom">
                <div class="map-wrap">
                    <div class="left">
                        <div class="map">
                            <div ref="chart" id="myChart" style="width:100%;height:100%"></div>
                        </div>
                        <div class="map-desc">
                            <div class="name-line">
                                <h5>{{mapData[index].name+mapData[index].units}}</h5>
                                <span
                                    class="first"
                                    v-show="mapData[index].number1===0"
                                >该地区暂无配送网点（规划中）</span>
                                <span class="first" v-show="mapData[index].number1!==0">
                                    <span>配送中心</span>
                                    <span class="number">{{mapData[index].number1}}</span>
                                </span>
                                <span v-show="mapData[index].number1!==0">
                                    <span>总配送线路</span>
                                    <span class="number">{{mapData[index].number2}}</span>
                                </span>
                            </div>
                            <div class="aging" v-show="mapData[index].number1!==0">
                                <h5>配送时效</h5>
                                <p v-html="mapData[index].content"></p>
                                <p>配送中心所在城市，24H到达，
                                    <br>后期规划：全市90%以上乡镇区域，48H小时到达。
                                </p>
                            </div>
                            <div class="aging" v-show="mapData[index].number1!==0">
                                <h5>特殊配送产品</h5>
                                <p>当日达：仓储所在地覆盖范围内的紧急订单，当日11点钟之前下单，当天送达。</p>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="legends" v-show="mapData[index].number1!==0">
                            <div class="legend">
                                <img src="../../images/icon/tcps_ck.png">
                                <h6>仓库</h6>
                            </div>
                            <div class="legend">
                                <img src="../../images/icon/tcps_psfw.png">
                                <h6>配送范围</h6>
                            </div>
                            <div class="legend">
                                <img src="../../images/icon/tcps_24h.png">
                                <h6>24h送达区域</h6>
                            </div>
                            <div class="legend">
                                <img src="../../images/icon/tcps_48h.png">
                                <h6>48h送达区域</h6>
                            </div>
                        </div>
                        <div :class="{'map-right-img':true,'map-right-img-default':mapData[index].number1===0}">
                            <img :src="mapData[index].url">
                        </div>
                        <div
                            class="bottom-text"
                            v-show="mapData[index].number1!==0"
                        >配送中心辐射全境（乡镇、街道）</div>
                    </div>
                </div>
            </div>
        </ContentBox>
        <div class="bottom-2-bg">
            <ContentBox title="时效产品使命必达" text="提供差异化的时效产品，根据供需选择最优配置">
                <div class="bottom-2">
                    <div class="bottom-card-wrap">
                        <div class="line">
                            <div class="card-item">
                                <div class="card-top">
                                    <div class="card-top-left">次日达</div>
                                    <div class="card-top-right">24H</div>
                                </div>
                                <div class="card-middle">
                                    <span class="text-left">当日</span>
                                    <span class="blue text-left">20:00</span>
                                    <span class="text-left">前下单</span>
                                    <span class="middle-icon">
                                        <img
                                            :src="isMobile?require('../../images/icon/ds_yd_lianjie.png'):require('../../images/icon/ds_lianjie.png')"
                                        >
                                    </span>
                                    <span class="text-left">次日</span>
                                    <span class="blue text-left">23:59</span>
                                    <span class="text-left">前签收</span>
                                </div>
                                <div class="card-bottom">注：同城或0（含）-100KM（不含）</div>
                            </div>
                            <div class="card-item">
                                <div class="card-top">
                                    <div class="card-top-left">隔日达</div>
                                    <div class="card-top-right">48H</div>
                                </div>
                                <div class="card-middle">
                                    <span class="text-left">当日</span>
                                    <span class="blue text-left">20:00</span>
                                    <span class="text-left">前下单</span>
                                    <span class="middle-icon">
                                        <img
                                            :src="isMobile?require('../../images/icon/ds_yd_lianjie.png'):require('../../images/icon/ds_lianjie.png')"
                                        >
                                    </span>
                                    <span class="text-left">隔日</span>
                                    <span class="blue text-left">23:59</span>
                                    <span class="text-left">前签收</span>
                                </div>
                                <div class="card-bottom">注：100（含）-300KM（不含）</div>
                            </div>
                            <div class="card-item">
                                <div class="card-top">
                                    <div class="card-top-left">三日达</div>
                                    <div class="card-top-right">72H</div>
                                </div>
                                <div class="card-middle">
                                    <span class="text-left">当日</span>
                                    <span class="blue text-left">20:00</span>
                                    <span class="text-left">前下单</span>
                                    <span class="middle-icon">
                                        <img
                                            :src="isMobile?require('../../images/icon/ds_yd_lianjie.png'):require('../../images/icon/ds_lianjie.png')"
                                        >
                                    </span>
                                    <span class="text-left">第四日</span>
                                    <span class="blue text-left">23:59</span>
                                    <span class="text-left">前签收</span>
                                </div>
                                <div class="card-bottom">注：300（含）-500KM（不含）</div>
                            </div>
                        </div>
                        <div class="line">
                            <div class="card-item">
                                <div class="card-top">
                                    <div class="card-top-left">四日达</div>
                                    <div class="card-top-right">96H</div>
                                </div>
                                <div class="card-middle">
                                    <span class="text-left">当日</span>
                                    <span class="blue text-left">20:00</span>
                                    <span class="text-left">前下单</span>
                                    <span class="middle-icon">
                                        <img
                                            :src="isMobile?require('../../images/icon/ds_yd_lianjie.png'):require('../../images/icon/ds_lianjie.png')"
                                        >
                                    </span>
                                    <span class="text-left">第五日</span>
                                    <span class="blue text-left">23:59</span>
                                    <span class="text-left">前签收</span>
                                </div>
                                <div
                                    class="card-bottom"
                                >注：500KM（不含）以上，西藏、青海、新疆等部分区域不在四日达覆盖范围内，以已约定的时效为准</div>
                            </div>
                            <div class="card-item">
                                <div class="card-top">
                                    <div class="card-top-left">定日达</div>
                                    <div class="card-top-right">约定日期</div>
                                </div>
                                <div class="card-middle">
                                    <div class="text-left">客户选择指定日期签收</div>
                                </div>
                                <div
                                    class="card-bottom"
                                >注：不限里程，不包括次日达、隔日达、三日达。四日达所覆盖的日期，最长不超过订单日期后15天</div>
                            </div>
                            <div class="card-item">
                                <div class="card-top">
                                    <div class="card-top-left">限日达</div>
                                    <div class="card-top-right-last">
                                        <p style="marginTop:5px">承诺日期内</p>
                                        <p>任意一天</p>
                                    </div>
                                </div>
                                <div class="card-middle">
                                    <div class="text-left">承诺日期内任意一天均可签收</div>
                                </div>
                                <div class="card-bottom">注：不限里程，客户选择此项，代表在承诺日期内任何一天均可收货</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentBox>
        </div>
    </div>
</template>

<script>
import ContentBox from '../common/content-box';
// 引入基本模板
let echarts = require('echarts/lib/echarts');
require('echarts/map/js/china.js'); // 引入中国地图数据
// 引入提示框和title组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
export default {
    metaInfo: {
        title: '安得智联-同城配送|城市配送',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '安得智联同城配送,城市配送'
        },{                 // set meta
            name: 'description',
            content: '安得智联同城配送,轻松解决各类城市配送痛点,专业高效,保证服务品质与安全,选择安得更省心更安心.'
        }]
    },
    name: 'city-wide',
    props: ['userJson'],
    data() {
        return {
            chart: null,
            current: 'tab0',
            isMobile: this.COMMON.isMobile,
            index: 0,
            mapData: [
                {
                    name: '天津',
                    units: '市',
                    value: 1,
                    number1: 1,
                    number2: 1168,
                    content: '24H333条、48H700条、72H135条；',
                    url: require('../../images/map/天津.png')
                },
                {
                    name: '山东',
                    units: '省',
                    value: 0,
                    number1: 9,
                    number2: 7995,
                    content: '24H1877条、48H4282条、72H1769条、96H67条；',
                    url: require('../../images/map/山东.png')
                },
                {
                    name: '广东',
                    units: '省',
                    value: 0,
                    number1: 11,
                    number2: 15553,
                    content: '24H2241条、48H6022条、72H4550条、96H2740条；',
                    url: require('../../images/map/广东.png')
                },
                {
                    name: '四川',
                    units: '省',
                    value: 0,
                    number1: 4,
                    number2: 14770,
                    content:
                        '24H1836条、48H5608条、72H4412条、96小时1100条、96H以上1814条；',
                    url: require('../../images/map/四川.png')
                },
                {
                    name: '江西',
                    units: '省',
                    value: 0,
                    number1: 4,
                    number2: 1756,
                    content: '24H803条、48H912条、72H40条、96H1条；',
                    url: require('../../images/map/江西.png')
                },
                {
                    name: '黑龙江',
                    units: '省',
                    value: 0,
                    number1: 3,
                    number2: 3346,
                    content:
                        '24H472条、48H1076条、72H1742条、96H54条、96H以上2条；',
                    url: require('../../images/map/黑龙江.png')
                },
                {
                    name: '贵州',
                    units: '省',
                    value: 0,
                    number1: 3,
                    number2: 2716,
                    content: '24H435条、48H1611条、72H667条、96H3条；',
                    url: require('../../images/map/贵州.png')
                },
                {
                    name: '甘肃',
                    units: '省',
                    value: 0,
                    number1: 1,
                    number2: 2821,
                    content: '24H223条、48H875条、72H953条、96H645条、96H以上125条；',
                    url: require('../../images/map/甘肃.png')
                },
                {
                    name: '重庆',
                    units: '市',
                    value: 0,
                    number1: 3,
                    number2: 2935,
                    content: '24H608条、48H1833条、72H494条；',
                    url: require('../../images/map/重庆.png')
                },
                {
                    name: '云南',
                    units: '省',
                    value: 0,
                    number1: 2,
                    number2: 1882,
                    content: '24H184条、48H518条、72H695条、96H485条；',
                    url: require('../../images/map/云南.png')
                },
                {
                    name: '新疆',
                    units: '维吾尔自治区',
                    value: 0,
                    number1: 1,
                    number2: 486,
                    content: '24H140条、48H138条、72H8条、96H187条、96H以上13条；',
                    url: require('../../images/map/新疆.png')
                },
                {
                    name: '辽宁',
                    units: '省',
                    value: 0,
                    number1: 3,
                    number2: 4481,
                    content: '24H577条、48H2085条、72H1503条、96H316条；',
                    url: require('../../images/map/辽宁.png')
                },
                {
                    name: '上海',
                    units: '市',
                    value: 0,
                    number1: 1,
                    number2: 485,
                    content: '24H485条；',
                    url: require('../../images/map/上海.png')
                },
                {
                    name: '内蒙古',
                    units: '自治区',
                    value: 0,
                    number1: 1,
                    number2: 981,
                    content:
                        '24H159条、48H385条、72H294条、96H78条、96H以上65条；',
                    url: require('../../images/map/内蒙古.png')
                },
                {
                    name: '吉林',
                    units: '省',
                    value: 0,
                    number1: 1,
                    number2: 1337,
                    content: '24H193条、48H572条、72H393条、96H177条、96H以上2条；',
                    url: require('../../images/map/吉林.png')
                },
                {
                    name: '山西',
                    units: '省',
                    value: 0,
                    number1: 2,
                    number2: 5821,
                    content: '24H837条、48H2721条、72H2263条；',
                    url: require('../../images/map/山西.png')
                },
                {
                    name: '陕西',
                    units: '省',
                    value: 0,
                    number1: 3,
                    number2: 4007,
                    content: '24H987条、48H1836条、72H1184条；',
                    url: require('../../images/map/陕西.png')
                },
                {
                    name: '安徽',
                    units: '省',
                    value: 0,
                    number1: 7,
                    number2: 3420,
                    content: '24H1087条、48H1559条、72H774条；',
                    url: require('../../images/map/安徽.png')
                },
                {
                    name: '广西',
                    units: '壮族自治区',
                    value: 0,
                    number1: 4,
                    number2: 2141,
                    content: '24H431条、48H1054条、72H655条、96H1条；',
                    url: require('../../images/map/广西.png')
                },
                {
                    name: '湖南',
                    units: '省',
                    value: 0,
                    number1: 8,
                    number2: 3591,
                    content: '24H1869条、48H1418条、72H304条；',
                    url: require('../../images/map/湖南.png')
                },
                {
                    name: '江苏',
                    units: '省',
                    value: 0,
                    number1: 11,
                    number2: 2872,
                    content: '24H1740条、48H1117条、72H15条；',
                    url: require('../../images/map/江苏.png')
                },
                {
                    name: '浙江',
                    units: '省',
                    value: 0,
                    number1: 6,
                    number2: 4061,
                    content: '24H1375条、48H1903条、72H783条；',
                    url: require('../../images/map/浙江.png')
                },
                {
                    name: '河北',
                    units: '省',
                    value: 0,
                    number1: 6,
                    number2: 2762,
                    content: '24H1502条、48H1239条、72H21条；',
                    url: require('../../images/map/河北.png')
                },
                {
                    name: '海南',
                    units: '省',
                    value: 0,
                    number1: 1,
                    number2: 236,
                    content: '24H73条、48H163条；',
                    url: require('../../images/map/海南.png')
                },
                {
                    name: '河南',
                    units: '省',
                    value: 0,
                    number1: 9,
                    number2: 5343,
                    content: '24H1936条、48H3214条、72H193条；',
                    url: require('../../images/map/河南.png')
                },
                {
                    name: '湖北',
                    units: '省',
                    value: 0,
                    number1: 7,
                    number2: 4056,
                    content: '24H781条、48H2100条、72H992条、96H183条；',
                    url: require('../../images/map/湖北.png')
                },
                {
                    name: '北京',
                    units: '市',
                    value: 0,
                    number1: 1,
                    number2: 537,
                    content: '24H339条、48H179条、72H19条；',
                    url: require('../../images/map/北京.png')
                },
                {
                    name: '福建',
                    units: '省',
                    value: 0,
                    number1: 6,
                    number2: 3892,
                    content: '24H1123条、48H2061条、72H708；',
                    url: require('../../images/map/福建.png')
                },
                {
                    name: '宁夏',
                    units: '回族自治区',
                    value: 0,
                    number1: 1,
                    number2: 247,
                    content: '24H52条、48H129条、72H66；',
                    url: require('../../images/map/tcps_default_jsz.png')
                },
                {
                    name: '青海',
                    units: '省',
                    value: 0,
                    number1: 0,
                    number2: 0,
                    content: '',
                    url: require('../../images/map/tcps_default_jsz.png')
                },
                {
                    name: '西藏',
                    units: '自治区',
                    value: 0,
                    number1: 0,
                    number2: 0,
                    content: '',
                    url: require('../../images/map/tcps_default_jsz.png')
                },
                {
                    name: '台湾',
                    units: '省',
                    value: 0,
                    number1: 0,
                    number2: 0,
                    content: '',
                    url: require('../../images/map/tcps_default_jsz.png')
                },
                {
                    name: '南海诸岛',
                    units: '',
                    value: 0,
                    number1: 0,
                    number2: 0,
                    content: '',
                    url: require('../../images/map/tcps_default_jsz.png')
                }
            ]
        };
    },
    mounted() {
        this.chinaConfigure();
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    methods: {
        showTab(tab) {
            this.current = tab;
        },
        chinaConfigure() {
            var bar_dv = this.$refs.chart;
            const that = this;
            let option = {
                title: {
                    text: that.isMobile ? '' : '鼠标点击查看',
                    left: 'left',
                    top: 21,
                    textStyle: {
                        color: '#ffffff',
                        fontStyle: 'normal',
                        fontSize: 14
                    }
                },
                dataRange: {
                    show: false,
                    x: 'left',
                    y: 'bottom',
                    splitList: [
                        { start: 0, end: 0, color: '#fbfbfb' }, //当值为0时，区域背景
                        { start: 1, end: 1, color: '#ff8b00' } //当值为1时，区域背景
                    ]
                },
                series: [
                    {
                        type: 'map',
                        map: 'china',
                        zoom: 1.2,
                        label: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaColor: '#fbfbfb',
                                borderColor: '#bababa',
                                borderWidth: 1
                            },
                            emphasis: {
                                areaColor: '#f0f0f0'
                            }
                        },
                        data: that.mapData
                    }
                ]
            };
            if (bar_dv) {
                let myChart = echarts.init(bar_dv);
                myChart.setOption(option);
                myChart.on('click', function(params) {
                    that.mapData.map((item, index) => {
                        if (item.name === params.name) {
                            that.mapData.map((sitem, sindex) => {
                                that.mapData[sindex].value = 0;
                            });
                            that.index = index;
                            that.mapData[index].value = 1;
                            myChart.setOption(option);
                        }
                    });
                });
            }
        }
    },
    components: {
        ContentBox
    }
};
</script>


<style lang="less">
    @import url(./style/city-wide.less);
</style>